import React from 'react';
import WaitlistFields from './waitlistFields';

export default function AttendanceSection({ form, onChange }) {
  return (
    <>
      <label htmlFor="attendanceMode">Attendance
        <select
          id="attendanceMode"
          name="attendanceMode"
          value={form.attendanceMode === 'ticketed' ? 'none' : form.attendanceMode}
          onChange={onChange}
          className="input"
        >
          <option value="none">No tracking</option>
          <option value="rsvp">Free RSVP</option>
        </select>
      </label>

      <label htmlFor="capacity">Capacity (optional)
        <input
          id="capacity"
          name="capacity"
          type="number"
          min="0"
          placeholder="Leave blank for unlimited"
          value={form.capacity}
          onChange={onChange}
          className="input"
        />
      </label>
      <WaitlistFields form={form} onChange={onChange} />
    </>
  );
}
